import { render, staticRenderFns } from "./CompanyHonor.vue?vue&type=template&id=2a1ea5b0&scoped=true"
import script from "./CompanyHonor.vue?vue&type=script&lang=js"
export * from "./CompanyHonor.vue?vue&type=script&lang=js"
import style0 from "./CompanyHonor.vue?vue&type=style&index=0&id=2a1ea5b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1ea5b0",
  null
  
)

export default component.exports